import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components6';
import { IconOption } from 'rwl-shared/dist/models/widget';
import { getIcon, getIconColor } from '../../../../utils';
import { When } from 'react-if';
import { faStar } from '@fortawesome/pro-solid-svg-icons';

type JobMarkerContentProps = {
    icon: IconOption;
    iconTint: string;
    onClick?: () => void;
    isSelected?: boolean;
    hasReview?: boolean;
};

const MarkerContainer = styled.div.withConfig({
    shouldForwardProp: (prop) =>
        !['colors', 'isSelected', 'iconTint'].includes(prop),
})<{
    colors: { fill: string; backDrop: string };
    isSelected?: boolean;
    iconTint?: string;
}>`
    display: inline-flex;
    border: ${({ isSelected, iconTint }) =>
        isSelected ? `2px solid ${iconTint}` : 'none'};
    border-radius: 50%;
    transition: all 0.2s ease;

    :hover {
        background: ${({ colors }) => colors.fill};

        svg {
            background: ${({ colors }) => colors.fill};
            color: ${({ colors }) => colors.backDrop};
        }
    }
`;

const IconContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => !['colors'].includes(prop),
})<{ colors: { fill: string; backDrop: string } }>`
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ colors }) => colors.backDrop};
    border-radius: 50%;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    height: 20px;
    width: 20px;
`;

const StarContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--rwl-background-level1);
    border-radius: 50%;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    height: 16px;
    width: 16px;
    position: absolute;
    top: -8px;
    right: -8px;
`;

const JobMarkerContent = ({
    icon,
    iconTint,
    onClick,
    isSelected,
    hasReview,
}: JobMarkerContentProps) => (
    <>
        <When condition={hasReview}>
            <StarContainer>
                <FontAwesomeIcon icon={faStar} color="#FFB400" />
            </StarContainer>
        </When>
        <MarkerContainer
            colors={getIconColor(icon, iconTint)}
            isSelected={isSelected}
            iconTint={iconTint}
        >
            <IconContainer
                className="jobMarker"
                colors={getIconColor(icon, iconTint)}
            >
                <FontAwesomeIcon
                    icon={getIcon(icon)}
                    color={getIconColor(icon, iconTint).fill}
                    size="1x"
                    onClick={onClick}
                />
            </IconContainer>
        </MarkerContainer>
    </>
);

export default JobMarkerContent;
